module.exports = __webpack_public_path__ + "img/red_003.8efc052d.png";